// extracted by mini-css-extract-plugin
export default {"customLogo":"EmailTemplateLogo_customLogo__RbpmK"};